import React from 'react';
import { Progress } from 'antd';
import { Store, ShoppingBasket, MapPin, Users, Building2 } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';
import { computeStoreAnalytics, coverageColor } from './storeAnalytics.controller';
import { t } from '../../../company/labels';

/** "n / total" value with the total de-emphasized. */
const OfTotal = ({ value, total }) => (
    <>
        {formatNumber(value)}
        <span className="ml-1.5 text-sm font-medium text-surface-400">/ {formatNumber(total)}</span>
    </>
);

/** Coverage footer: percentage + thin progress bar. */
const Coverage = ({ percent }) => (
    <div>
        <div className="flex items-center justify-between text-xs text-surface-500 mb-1">
            <span>Cobertura</span>
            <span className="font-semibold text-surface-900 tabular-nums">{percent}%</span>
        </div>
        <Progress percent={percent} size={['100%', 6]} showInfo={false} strokeColor={coverageColor(percent)} className="m-0" />
    </div>
);

export default function StoreAnalytics({ stores }) {
    const { activeStores, modernoStores, tradicionalStores, storesWithCoordinates, coordinatesCoverage, storesWithPromotors, promotorCoverage } =
        computeStoreAnalytics(stores);

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            <StatCard label="Total PDVs" value={formatNumber(activeStores)} icon={<Store />} tone="brand" hint="Pisos activos" />
            <StatCard label="Moderno" value={formatNumber(modernoStores)} icon={<Building2 />} tone="info" hint="Grandes superficies" />
            <StatCard label="Tradicional" value={formatNumber(tradicionalStores)} icon={<ShoppingBasket />} tone="warning" hint="Tiendas locales" />
            <StatCard
                label="Cobertura GPS"
                value={<OfTotal value={storesWithCoordinates} total={activeStores} />}
                icon={<MapPin />}
                tone="violet"
                footer={<Coverage percent={coordinatesCoverage} />}
            />
            <StatCard
                label={`Con ${t('promotores')}`}
                value={<OfTotal value={storesWithPromotors} total={activeStores} />}
                icon={<Users />}
                tone="success"
                footer={<Coverage percent={promotorCoverage} />}
            />
        </div>
    );
}
